export default "__VITE_ASSET__DKs4$mZw__"